export function PunchManagementSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/punch-management.svg'"></ng-include>`
    }
}